import React, { useEffect, useRef } from 'react';

const ShopifyBuyButton = ({ productId, variantId, containerId }) => {
  const containerRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    // Prevent double initialization
    if (initialized.current) return;
    
    const initShopifyButton = () => {
      if (!window.ShopifyBuy || !window.ShopifyBuy.UI) {
        console.log(`Shopify SDK not ready for ${containerId}`);
        return;
      }

      try {
        const client = window.ShopifyBuy.buildClient({
          domain: 'cad1cy-wf.myshopify.com',
          storefrontAccessToken: '403261eb464be1acf93f2466cf126215',
        });

        window.ShopifyBuy.UI.onReady(client).then((ui) => {
          if (!containerRef.current || initialized.current) return;
          
          const componentOptions = {
            id: productId,
            node: containerRef.current,
            moneyFormat: '%24%7B%7Bamount%7D%7D',
            options: {
              product: {
                styles: {
                  product: {
                    "@media (min-width: 601px)": {
                      "max-width": "100%",
                      "margin-left": "0px",
                      "margin-bottom": "0px"
                    }
                  },
                  button: {
                    "font-family": "inherit",
                    "font-size": "14px",
                    "padding": "12px 24px",
                    "font-weight": "600",
                    ":hover": {
                      "background-color": "#5b21b6"
                    },
                    "background-color": "#6366f1",
                    ":focus": {
                      "background-color": "#5b21b6"
                    },
                    "border-radius": "6px"
                  }
                },
                contents: {
                  img: false,
                  title: false,
                  price: false,
                  options: false,  // Hide variant/size dropdown
                  button: false,
                  buttonWithQuantity: true,  // Enable Add to Cart with quantity
                  quantityInput: true
                },
                text: {
                  button: "Add to Cart"
                }
              },
              productSet: {
                styles: {
                  products: {
                    "@media (min-width: 601px)": {
                      "margin-left": "-20px"
                    }
                  }
                }
              },
              modalProduct: {
                contents: {
                  img: false,
                  imgWithCarousel: true,
                  button: false,
                  buttonWithQuantity: true
                },
                styles: {
                  product: {
                    "@media (min-width: 601px)": {
                      "max-width": "100%",
                      "margin-left": "0px",
                      "margin-bottom": "0px"
                    }
                  }
                },
                text: {
                  button: "Add to cart"
                }
              },
              option: {},
              cart: {
                text: {
                  total: "Subtotal",
                  notice: "",
                  button: "Checkout",
                  noteDescription: "Special instructions"
                },
                contents: {
                  note: true
                },
                popup: false
              },
              toggle: {}
            }
          };
          
          // Add variant ID if provided
          if (variantId) {
            componentOptions.variantId = variantId;
          }
          
          ui.createComponent('product', componentOptions);
          
          initialized.current = true;
        }).catch(error => {
          console.error(`Error initializing Shopify button for ${containerId}:`, error);
        });
      } catch (error) {
        console.error(`Error in Shopify button setup for ${containerId}:`, error);
      }
    };

    // Load Shopify SDK if not loaded
    if (!window.ShopifyBuy) {
      const script = document.createElement('script');
      script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
      script.async = true;
      script.onload = () => {
        setTimeout(initShopifyButton, 100);
      };
      document.head.appendChild(script);
    } else {
      setTimeout(initShopifyButton, 100);
    }

    // Cleanup
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [productId, variantId, containerId]);

  return (
    <div ref={containerRef} id={containerId} className="shopify-buy-button-container w-full">
    </div>
  );
};

export default ShopifyBuyButton;
